import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type StayAreaFragment = {
  __typename?: 'JoyStayArea';
  id: string;
  name: string;
  areaType?: string | null;
  bestForTags?: Array<string> | null;
  address?: string | null;
  description?: string | null;
  proposedNoteFromHostToGuest?: string | null;
  watchOuts?: string | null;
  whyThisAreaIsAGreatPick?: string | null;
  bounds?: {
    __typename?: 'LocationBoundsOutput';
    ne: { __typename?: 'LocationCoordinates'; lng: number };
    sw: { __typename?: 'LocationCoordinates'; lat: number; lng: number };
  } | null;
  center?: { __typename?: 'LocationCoordinates'; lat: number; lng: number } | null;
  photos?: Array<{ __typename?: 'Photo'; id: string; url: string }> | null;
  customPhotos?: Array<{ __typename?: 'Photo'; id: string; url: string; altTag?: string | null }> | null;
  distances?: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }> | null;
};

export type StayAreasQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type StayAreasQuery = {
  __typename?: 'Query';
  stayAreas: Array<{
    __typename?: 'JoyStayArea';
    id: string;
    name: string;
    areaType?: string | null;
    bestForTags?: Array<string> | null;
    address?: string | null;
    description?: string | null;
    proposedNoteFromHostToGuest?: string | null;
    watchOuts?: string | null;
    whyThisAreaIsAGreatPick?: string | null;
    bounds?: {
      __typename?: 'LocationBoundsOutput';
      ne: { __typename?: 'LocationCoordinates'; lng: number };
      sw: { __typename?: 'LocationCoordinates'; lat: number; lng: number };
    } | null;
    center?: { __typename?: 'LocationCoordinates'; lat: number; lng: number } | null;
    photos?: Array<{ __typename?: 'Photo'; id: string; url: string }> | null;
    customPhotos?: Array<{ __typename?: 'Photo'; id: string; url: string; altTag?: string | null }> | null;
    distances?: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }> | null;
  }>;
};

export type RemoveStayAreaMutationVariables = Types.Exact<{
  payload: Types.RemoveStayAreaPayloadV2;
}>;

export type RemoveStayAreaMutation = { __typename?: 'Mutation'; removeStayAreaV2: { __typename?: 'JoyStayArea'; id: string } };

export type UpdateStayAreaMutationVariables = Types.Exact<{
  payload: Types.UpdateStayAreaRequest;
}>;

export type UpdateStayAreaMutation = { __typename?: 'Mutation'; updateStayArea: { __typename?: 'JoyStayArea'; id: string; name: string } };

export type AddStayAreaMutationVariables = Types.Exact<{
  payload: Types.AddStayAreaRequest;
}>;

export type AddStayAreaMutation = {
  __typename?: 'Mutation';
  addStayArea: {
    __typename?: 'JoyStayArea';
    id: string;
    name: string;
    areaType?: string | null;
    bestForTags?: Array<string> | null;
    address?: string | null;
    description?: string | null;
    proposedNoteFromHostToGuest?: string | null;
    watchOuts?: string | null;
    whyThisAreaIsAGreatPick?: string | null;
    bounds?: {
      __typename?: 'LocationBoundsOutput';
      ne: { __typename?: 'LocationCoordinates'; lng: number };
      sw: { __typename?: 'LocationCoordinates'; lat: number; lng: number };
    } | null;
    center?: { __typename?: 'LocationCoordinates'; lat: number; lng: number } | null;
    photos?: Array<{ __typename?: 'Photo'; id: string; url: string }> | null;
    customPhotos?: Array<{ __typename?: 'Photo'; id: string; url: string; altTag?: string | null }> | null;
    distances?: Array<{ __typename?: 'TravelDistanceBetweenPoints'; durationMinutes?: number | null; km: number; mi: number; type: Types.DistancesBetweenPointsType }> | null;
  };
};

export const StayAreaFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StayArea' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyStayArea' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'areaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bestForTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bounds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ne' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'lng' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sw' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'center' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'watchOuts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisAreaIsAGreatPick' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhotos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const StayAreasDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StayAreas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stayAreas' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StayArea' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StayArea' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyStayArea' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'areaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bestForTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bounds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ne' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'lng' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sw' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'center' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'watchOuts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisAreaIsAGreatPick' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhotos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useStayAreasQuery__
 *
 * To run a query within a React component, call `useStayAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useStayAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStayAreasQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useStayAreasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StayAreasQuery, StayAreasQueryVariables>) {
  return ApolloReactHooks.useQuery<StayAreasQuery, StayAreasQueryVariables>(StayAreasDocument, baseOptions);
}
export function useStayAreasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StayAreasQuery, StayAreasQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<StayAreasQuery, StayAreasQueryVariables>(StayAreasDocument, baseOptions);
}
export type StayAreasQueryHookResult = ReturnType<typeof useStayAreasQuery>;
export type StayAreasLazyQueryHookResult = ReturnType<typeof useStayAreasLazyQuery>;
export type StayAreasQueryResult = Apollo.QueryResult<StayAreasQuery, StayAreasQueryVariables>;
export const RemoveStayAreaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveStayArea' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveStayAreaPayloadV2' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeStayAreaV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveStayAreaMutationFn = Apollo.MutationFunction<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>;

/**
 * __useRemoveStayAreaMutation__
 *
 * To run a mutation, you first call `useRemoveStayAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStayAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStayAreaMutation, { data, loading, error }] = useRemoveStayAreaMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRemoveStayAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>) {
  return ApolloReactHooks.useMutation<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>(RemoveStayAreaDocument, baseOptions);
}
export type RemoveStayAreaMutationHookResult = ReturnType<typeof useRemoveStayAreaMutation>;
export type RemoveStayAreaMutationResult = Apollo.MutationResult<RemoveStayAreaMutation>;
export type RemoveStayAreaMutationOptions = Apollo.BaseMutationOptions<RemoveStayAreaMutation, RemoveStayAreaMutationVariables>;
export const UpdateStayAreaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateStayArea' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateStayAreaRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateStayArea' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateStayAreaMutationFn = Apollo.MutationFunction<UpdateStayAreaMutation, UpdateStayAreaMutationVariables>;

/**
 * __useUpdateStayAreaMutation__
 *
 * To run a mutation, you first call `useUpdateStayAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStayAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStayAreaMutation, { data, loading, error }] = useUpdateStayAreaMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateStayAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStayAreaMutation, UpdateStayAreaMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateStayAreaMutation, UpdateStayAreaMutationVariables>(UpdateStayAreaDocument, baseOptions);
}
export type UpdateStayAreaMutationHookResult = ReturnType<typeof useUpdateStayAreaMutation>;
export type UpdateStayAreaMutationResult = Apollo.MutationResult<UpdateStayAreaMutation>;
export type UpdateStayAreaMutationOptions = Apollo.BaseMutationOptions<UpdateStayAreaMutation, UpdateStayAreaMutationVariables>;
export const AddStayAreaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddStayArea' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddStayAreaRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addStayArea' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StayArea' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StayArea' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyStayArea' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'areaType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bestForTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bounds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ne' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'lng' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sw' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'center' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
          { kind: 'Field', name: { kind: 'Name', value: 'watchOuts' } },
          { kind: 'Field', name: { kind: 'Name', value: 'whyThisAreaIsAGreatPick' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customPhotos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'altTag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distances' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'km' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mi' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddStayAreaMutationFn = Apollo.MutationFunction<AddStayAreaMutation, AddStayAreaMutationVariables>;

/**
 * __useAddStayAreaMutation__
 *
 * To run a mutation, you first call `useAddStayAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStayAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStayAreaMutation, { data, loading, error }] = useAddStayAreaMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddStayAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddStayAreaMutation, AddStayAreaMutationVariables>) {
  return ApolloReactHooks.useMutation<AddStayAreaMutation, AddStayAreaMutationVariables>(AddStayAreaDocument, baseOptions);
}
export type AddStayAreaMutationHookResult = ReturnType<typeof useAddStayAreaMutation>;
export type AddStayAreaMutationResult = Apollo.MutationResult<AddStayAreaMutation>;
export type AddStayAreaMutationOptions = Apollo.BaseMutationOptions<AddStayAreaMutation, AddStayAreaMutationVariables>;
